import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiResponse } from "../../../types/APIResponse";
import api from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { CreateNoteByAdmin, FoundUpdateNoteByAdmin, LostItemLogsData, UpdateNoteByAdmin } from "../../../types/ActivityLog";

// Async Thunks
export const fetchAllLostItemLogs = createAsyncThunk<LostItemLogsData[], { lostId: string | null, withDeleted?: boolean, keepPaymentLog?: boolean }, { rejectValue: string }>("activityLog/fetchAllLostItemLogs", async ({ lostId, withDeleted, keepPaymentLog }, { rejectWithValue }) => {
  try {
    const lostIdParam = lostId ? `?lostId=${lostId}` : "";
    const withDeletedParam = withDeleted ? `&withDeleted=${withDeleted}` : "";
    const keepPaymentLogParam = `&kpl=${keepPaymentLog}`;
    const response = await api.get<ApiResponse<LostItemLogsData[]>>(`${apiEndpoints.activityLog.getAllLostItemLogs}${lostIdParam}${withDeletedParam}${keepPaymentLogParam}`);
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to fetch lost item logs.");
    }
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const createNoteByAdmin = createAsyncThunk<LostItemLogsData, CreateNoteByAdmin, { rejectValue: string }>("activityLog/createNoteByAdmin", async (newCreateNoteData, { rejectWithValue }) => {
  try {
    const response = await api.post<ApiResponse<LostItemLogsData>>(apiEndpoints.activityLog.createNoteByAdmin, { data: newCreateNoteData });
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to add note.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const updateNoteByAdmin = createAsyncThunk<LostItemLogsData, UpdateNoteByAdmin, { rejectValue: string }>("activityLog/updateNoteByAdmin", async (updatedNoteDataData, { rejectWithValue }) => {
  try {
    const response = await api.post<ApiResponse<LostItemLogsData>>(`${apiEndpoints.activityLog.updateNoteByAdmin}/${updatedNoteDataData?.id}`, { data: updatedNoteDataData });
    if (response?.success) {
      return { ...response.data };
    } else {
      throw new Error(response.message || "Failed to update note.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const fetchAllFoundItemLogs = createAsyncThunk<LostItemLogsData[], { foundId: string | null, withDeleted?: boolean }, { rejectValue: string }>("activityLog/fetchAllFoundItemLogs", async ({ foundId, withDeleted }, { rejectWithValue }) => {
  try {
    const foundIdParam = foundId ? `?foundId=${foundId}` : "";
    const withDeletedParam = withDeleted ? `&withDeleted=${withDeleted}` : "";
    const response = await api.get<ApiResponse<LostItemLogsData[]>>(`${apiEndpoints.activityLog.getAllFoundItemLogs}${foundIdParam}${withDeletedParam}`);
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to fetch Found item logs.");
    }
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const createNoteByAdminForFound = createAsyncThunk<LostItemLogsData, CreateNoteByAdmin, { rejectValue: string }>("activityLog/createNoteByAdminForFound", async (newCreateNoteDataForFound, { rejectWithValue }) => {
  try {
    const response = await api.post<ApiResponse<LostItemLogsData>>(apiEndpoints.activityLog.createNoteByAdminForFound, { data: newCreateNoteDataForFound });
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to add note for found.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const updateNoteByAdminForFound = createAsyncThunk<LostItemLogsData, FoundUpdateNoteByAdmin, { rejectValue: string }>(
  "activityLog/updateNoteByAdminForFound",
  async (updatedNoteDataDataForFound, { rejectWithValue }) => {
    try {
      const response = await api.post<ApiResponse<LostItemLogsData>>(`${apiEndpoints.activityLog.updateNoteByAdminForFound}/${updatedNoteDataDataForFound?.id}`, { data: updatedNoteDataDataForFound });
      if (response?.success) {
        return { ...response.data };
      } else {
        throw new Error(response.message || "Failed to update note for found.");
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
